import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'

const IdIslaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [islas, setIslas] = React.useState([])
  const [mostrarModalCrud, setMostrarModalCrud] = React.useState(false)

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.ISLAGRIFO, {}, true).then(({ data }) => {
      setIslas(data)
    })
  }, [])

  const onSuccess = React.useCallback(async () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.ISLAGRIFO, {}, true).then(({ data }) => {
      setIslas(data)
    })
    setMostrarModalCrud(false)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='ISLA' htmlFor='select-idIsla' md={3} alignRightAt='md' />
        <Col md={9}>
          <Form.InputGroup>
            <Field name='_idIsla'>
              {({ field }) => (
                <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-idIsla'>
                  <option key='seleccionar' value=''>
                    Seleccionar
                  </option>
                  {islas.map(x => (
                    <option key={x._id} value={x._id}>
                      {x.nombre}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarModalCrud(true)}>+</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModalCrud && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarModalCrud(false)}
          show={mostrarModalCrud}
          modalData={{}}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.ISLAGRIFO}
        />
      )}
    </>
  )
}

export default React.memo(IdIslaFormGroup)
